import React from "react";

import { ContentfulConditionalSection, MultiBannerItem } from "../../../../ContentfulTypes";
import MultiHeroBanner from "../../../UI/Banners/MultiHeroBanner/MultiHeroBanner";
import { ImageLoadingType } from "../../../UI/Image/Image";

import { PhoneMultiHeroBanner } from "./styles";

interface Props {
  conditionalMultiBanner?: ContentfulConditionalSection;
  useSharpImage?: boolean;
  index?: number;
  imageLoadingType?: ImageLoadingType;
}

const PhoneConditionalBanner = ({
  conditionalMultiBanner,
  useSharpImage,
  index = 0,
  imageLoadingType,
}: Props) => {
  if (conditionalMultiBanner?.sectionContent) {
    return (
      <PhoneMultiHeroBanner>
        <MultiHeroBanner
          data={conditionalMultiBanner?.sectionContent as MultiBannerItem}
          useSharpImage={useSharpImage}
          index={index}
          imageLoadingType={imageLoadingType}
        />
      </PhoneMultiHeroBanner>
    );
  }
  return null;
};

export default PhoneConditionalBanner;
